module.exports = __webpack_public_path__ + "img/box7-2-2.7dabf59e.png";